<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6" id="title-card-authorization">
            <q-icon :name="'img:' + require('@/assets/img/rocket.svg')"></q-icon> Detalles acción
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <slot name="body">
            <q-form ref="form">
              <div class="row">
                <!--Nombre-->
                <div class="col-12">
                  <div class="divLabel">Nombre de la accion</div>
                  <div class="divTexto">{{name}}</div>
                </div>
              </div>
              <div class="row">
                <!--Descripcion-->
                <div class="col-10">
                  <div class="divLabel">Descripcion</div>
                  <div class="divTexto">{{descripcion}}</div>
                </div>
              </div>
              <div class="row">
                <!--plazo-->
                <div class="col-2">
                  <div class="divLabel">Plazo</div>
                  <div class="divTexto">{{plazo}}</div>
                </div>
                <!--caracter-->
                <div class="col-3">
                  <div class="divLabel">Carácter</div>
                  <div class="divTexto">{{caracter}}</div>
                </div>
                <!--estado-->
                <div class="col-2">
                  <div class="divLabel">Fase</div>
                  <div class="divTexto"><QChipFases :value="label"/></div>
                </div>
                <!--Agente responsable-->
                <div class="col-3">
                  <div class="divLabel">Agente responsable</div>
                  <div class="divTexto">{{agenteResponsable}}</div>
                </div>
                <!--Presupuesto total-->
                <div class="col-2">
                  <div class="divLabel">Presupuesto total</div>
                  <div class="divTexto">{{presupuestoTotal}}</div>
                </div>
              </div>
            </q-form>
          </slot>
        </q-card-section>

        <ListadoObjetivosRelacionados :objetivosRelacionados="objetivosRelacionados" />

        <q-card-actions align="right" class="text-primary container-actions">
          <q-btn
            class="bSecondary"
            flat
            label="Cerrar"
            v-close-popup
            @click="cancel()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog, QForm, QIcon } from 'quasar';
import QChipFases from '@/components/PlanAccion/components/QChipFases.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import ListadoObjetivosRelacionados from './ListadoObjetivosRelacionados.vue';

export default {
  mixins: [Loading],
  components: {
    QDialog,
    QForm,
    QChipFases,
    QIcon,
    ListadoObjetivosRelacionados
  },
  props: {
    value: {
      required: true
    },
    datosAccion: {
      required: true
    }
  },
  data () {
    return {
      valueLocal: this.value,
      descripcion: '',
      name: '',
      plazo: '',
      caracter: '',
      label: '',
      agenteResponsable: '',
      presupuestoTotal: '',
      objetivosRelacionados: []
    };
  },
  created () {
    this.fillDetalle();
  },
  watch: {
    value: {
      handler: function () {
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
        this.fillDetalle();
      },
      immediate: true
    }
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    },
    fillDetalle () {
      this.name = this.datosAccion.name;
      this.descripcion = this.datosAccion.descripcion;
      this.plazo = this.datosAccion.plazo;
      this.caracter = this.datosAccion.caracter;
      this.label = this.datosAccion.fase ? this.datosAccion.fase.label : '';
      this.agenteResponsable = this.datosAccion.agenteResponsable;
      this.presupuestoTotal = this.datosAccion.presupuestoTotal;
      this.objetivosRelacionados = this.datosAccion.objetivosRelacionados;
    }
  }
};
</script>

<style lang="scss" scoped>
.card-authorization {
  min-width: 1600px;
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $azulcabecera;
      display: flex;
      align-items: center;
    }
    .q-icon{
      margin-right: 10px;
    }
  }
  .container-actions {
    padding-top: 15px;
  }
  &::v-deep {
    .q-field--standard .q-field__control:before {
      border-bottom-color: rgba(89, 89, 89, 0.5) !important;
    }
  }
}
.q-dialog__inner {
  div::v-deep {
    border-radius: 12px !important;
  }
}
.q-card {
  padding-left: 40px;
  padding-right: 40px;
}

  .row {
    div{
      padding: 4px;
    }
  }
  .divLabel {
    font-family: DINPro;
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.27px;
    color: #002f6c;
    margin-bottom:5px;
  }

</style>
